/** AUTO GENERATED FROM "node ./src/utils/convert-icons.js". DO NOT TOUCH. **/
import React from 'react'
import classNames from 'classnames'


class Icon extends React.PureComponent {
  render () {
    const { className, svgRef, ...otherProps } = this.props
    return (
      <svg id="f2a30af1-e725-41a0-99f8-c870b0cfeb4d" width="41" height="41" viewBox="0 0 41 41" fill="currentColor" className={classNames('nmx-icon', className)} ref={svgRef} {...otherProps}>
  <g id="bfacc783-ea23-4901-b056-074a5eb3c446">
    <g id="ff18933d-641c-4761-ab56-d89de266a653">
      <g id="b89b9517-9617-4248-b1ef-6e56a2e9ec8e">
        <g id="b21edbe2-d9f5-4aa0-87f3-ed8a2db5c563">
          <g id="b3c5abc7-6992-408c-961e-d34581eff5db">
            <g id="bb5dfe3b-9210-4c7e-a2ac-187e74e7472e">
              <g id="b60efb3d-efd9-4e10-b128-947433131d38">
                <path id="b51c3c73-8bb8-40d6-921f-a16efd4e512f" d="M21.5,40a19.5,19.5,0,0,0,0-39,19.7,19.7,0,0,0-4.7.57A19.5,19.5,0,0,0,21.5,40Z" transform="translate(-1)" style={{fill: "#edf0f3",stroke: "#fff",strokeWidth: "2px",fillRule: "evenodd"}}/>
                <circle id="a69f48e9-bac4-49ad-8388-d90edad5f487" cx="20.5" cy="20.5" r="15.5" style={{fill: "none",stroke: "#ffb81c",strokeWidth: "0.75px"}}/>
              </g>
              <g id="f60ecb98-4705-4714-8a77-72b16d21f622">
                <g id="ba11457c-d07c-4bf7-ae41-51a83e27708d">
                  <path id="e6a02730-f7db-4dac-a2f0-1c143f791b77" d="M21.25,11.07a12.08,12.08,0,0,1-8,2.95.26.26,0,0,0-.26.26v3.16a27.07,27.07,0,0,0,.18,3.4l0,.28A13.1,13.1,0,0,0,14.34,25a11.4,11.4,0,0,0,7,5.82.28.28,0,0,0,.18,0,11.4,11.4,0,0,0,7-5.82,14.84,14.84,0,0,0,1.31-6v-.32c0-.16,0-.32,0-.48v-4A.26.26,0,0,0,29.6,14a12.08,12.08,0,0,1-8-2.95A.27.27,0,0,0,21.25,11.07Zm.18.54,0,0a12.56,12.56,0,0,0,7.8,2.89h.06v3.74A15.23,15.23,0,0,1,28,24.81l-.05.11a10.87,10.87,0,0,1-6.51,5.39l-.05,0,.09,0a10.88,10.88,0,0,1-6.7-5.55l-.05-.11a13.84,13.84,0,0,1-1.17-5l0-.3c0-.35,0-.72,0-1.1V14.53h.06a12.56,12.56,0,0,0,7.8-2.89Z" transform="translate(-1)" style={{fill: "#0e497b"}}/>
                </g>
              </g>
            </g>
            <g id="f663ad01-49a3-4e5a-97e2-c6f0f8e56159">
              <path id="ff3c1232-1270-4994-a8de-875dd440a9e2" d="M23.5,18a2.61,2.61,0,0,0-1.69.63l-.31.27-.31-.27A2.61,2.61,0,0,0,19.46,18a2.66,2.66,0,0,0-1.79.67,2,2,0,0,0,.08,3.06L21.42,25a.12.12,0,0,0,.16,0l3.67-3.24a2,2,0,0,0,.08-3.06A2.66,2.66,0,0,0,23.54,18Z" transform="translate(-1)" style={{fill: "#ffb81c"}}/>
            </g>
          </g>
        </g>
      </g>
    </g>
  </g>
</svg>

    )
  }
}

Icon.displayName = 'HeartShieldWithBorderIcon'

export default Icon
